export default "__VITE_ASSET__CpjZonCh__"